
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Terminos y Condiciones',
  props: {
    token: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      activeTab: 'tab1'
    }
  },
  methods: {
    mostrarTab(tab: string){
      console.log("TAB A MOSTRAR: ",tab);
    }
  }
  
  
});
